module.exports = __webpack_public_path__ + "media/images/flags/am-b89186c1d0b76fcc1c8756316a708069.svg";